<template>
    <div class="version2-middle-top">
        <div class="row" v-for="item in list" :key="item.label" @click="detailClick(item)">
            <img :src="item.imgStr" alt="">
            <div class="row-right">
                <div class="label">{{ item.label }}</div>
                <div class="count" :style="style(item)">{{ item.count }}</div>
                <div class="per">同比+{{ item.per }} <img src="../../../../../static/version2/13.png"/></div>
            </div>
        </div>
    </div>
</template>

<script>
import { perIncrease } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      list: [
        {
          imgStr: require('../../../../../static/version2/专利总数图标.png'),
          label: '专利总数',
          count: 23232,
          per: '22.2%',
          color: '#E9BC5C',
          name: 'apply',
          exp: '专利类型=(发明申请 or 实用新型 or 外观设计)'
        },
        {
          imgStr: require('../../../../../static/version2/专利授权数图标.png'),
          label: '专利授权',
          count: 23232,
          per: '22.2%',
          color: '#2773D0',
          name: 'authorization',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计)'
        },
        {
          imgStr: require('../../../../../static/version2/专利有效数图标.png'),
          label: '专利有效',
          count: 2323,
          per: '22.2%',
          color: '#21F1E1',
          name: 'effect',
          exp: '专利类型=(发明授权 or 实用新型 or 外观设计) and 专利状态=(有效)'
        }
      ]
    }
  },
  mounted() {
    this.getTotal()
  },
  methods: {
    style(item) {
      return {backgroundImage: `-webkit-linear-gradient(top, #fff,${item.color})`}
    },
    getTotal() {
      perIncrease().then((res) => {
        console.log(res)
        res.data.forEach(item => {
          this.list.forEach(ele => {
            if (item.name === ele.name) {
              ele.per = item.per
              ele.count = item.count
            }
          })
        })
      })
    },
    detailClick(item) {
      this.jumpIpi(item.exp)
    }
  }
}
</script>
